
var ws = null

if (typeof WebSocket !== 'undefined') {
  ws = WebSocket
} else if (typeof MozWebSocket !== 'undefined') {
  ws = MozWebSocket
} else if (typeof window !== 'undefined') {
  ws = window.WebSocket || window.MozWebSocket
}

module.exports = ws



//////////////////
// WEBPACK FOOTER
// ../~/websocket-stream/ws-fallback.js
// module id = 1660
// module chunks = 0